module.exports = __webpack_public_path__ + "static/media/bts_lalela_170705_004_small.99548a82.jpg";